/* SETTINGS */
export const CHANGE_LOCALE = "CHANGE_LOCALE";

/* AUTH */
export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const LOGIN_USER_ERROR = "LOGIN_USER_ERROR";
export const REGISTER_USER = "REGISTER_USER";
export const REGISTER_USER_SUCCESS = "REGISTER_USER_SUCCESS";
export const REGISTER_USER_ERROR = "REGISTER_USER_ERROR";
export const LOGOUT_USER = "LOGOUT_USER";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_ERROR = "FORGOT_PASSWORD_ERROR";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_ERROR = "RESET_PASSWORD_ERROR";
export const SET_USER_DETAILS = "SET_USER_DETAILS";
export const SET_USER_DETAILS_LOADING = "SET_USER_DETAILS_LOADING";

/* MENU */
export const MENU_SET_CLASSNAMES = "MENU_SET_CLASSNAMES";
export const MENU_CONTAINER_ADD_CLASSNAME = "MENU_CONTAINER_ADD_CLASSNAME";
export const MENU_CLICK_MOBILE_MENU = "MENU_CLICK_MOBILE_MENU";
export const MENU_CHANGE_DEFAULT_CLASSES = "MENU_CHANGE_DEFAULT_CLASSES";
export const MENU_CHANGE_HAS_SUB_ITEM_STATUS =
  "MENU_CHANGE_HAS_SUB_ITEM_STATUS";

/* PROJECTS */
export const GET_PROJECTS = "PROJECT_GET_ALL";
export const SET_PROJECTS_LOADING = "SET_PROJECTS_LOADING";
export const SET_PROJECTS_FILTERS = "SET_PROJECTS_FILTERS";

/* PROJECT  */
export const GET_PROJECT = "GET_PROJECT";
export const SAVE_PROJECT = "SAVE_PROJECT";
export const SET_PROJECT_LOADING = "SET_PROJECT_LOADING";
export const SAVE_PROJECT_LOADING = "SAVE_PROJECT_LOADING";

export const PROJECT_PUBLISH_REQUEST = "PROJECT_PUBLISH_REQUEST";

export const SET_PROJECT_DETAILS_LOADING = "SET_PROJECT_DETAILS_LOADING";
export const GET_PROJECT_DETAILS = "GET_PROJECT_DETAILS";
export const SAVE_PROJECT_DETAILS = "SAVE_PROJECT_DETAILS";
export const GET_PROJECT_RESOURCES = "GET_PROJECT_RESOURCES";
export const SAVE_PROJECT_RESOURCE = "SAVE_PROJECT_RESOURCE";
export const GET_PROJECT_RESOURCE = "GET_PROJECT_RESOURCE";
export const DELETE_PROJECT_RESOURCE = "DELETE_PROJECT_RESOURCE";

/* MEDIA  */
export const GET_MEDIA = "GET_MEDIA";
export const SAVE_MEDIA = "SAVE_MEDIA";
export const LIST_MEDIA = "LIST_MEDIA";
export const SET_MEDIA_LOADING = "SET_MEDIA_LOADING";

/* CUSTOM MODAL */
export const OPEN_MODAL = "OPEN_MODAL";
export const CLOSE_MODAL = "CLOSE_MODAL";

/* ADMIN */
export const ADMIN_GET_PROJECTS = "ADMIN_GET_PROJECTS";
export const ADMIN_GET_BILLING_PLANS = "ADMIN_GET_BILLING_PLANS";
export const ADMIN_GET_USER_REALMS = "ADMIN_GET_USER_REALMS";
export const ADMIN_GET_USERS = "ADMIN_GET_USERS";
export const ADMIN_GET_REALM_BILLING = "ADMIN_GET_REALM_BILLING";

/* EDIT PROJECT */
export const SET_PROJECT_EDITOR = "SET_PROJECT_EDITOR";
export const SET_PROJECT_DETAILS_SETTING = "SET_PROJECT_DETAILS_SETTING";
export const SET_PROJECT_EDITOR_LOADING = "SET_PROJECT_EDITOR_LOADING";
export const ADD_VARIANT = "ADD_VARIANT";
export const SAVE_VARIANT = "SAVE_VARIANT";
export const DELETE_VARIANT = "DELETE_VARIANT";
export const SYNC_SHOPIFY_VARIANTS = "SYNC_SHOPIFY_VARIANTS";
export const SET_MODEL = "SET_MODEL";

/* REPORTS */
export const GET_PROJECT_REPORT = "GET_PROJECT_REPORT";
export const SET_PROJECT_ANALYTICS_LOADING = "SET_PROJECT_ANALYTICS_LOADING";
export const GET_PROJECT_ANALYTICS = "GET_PROJECT_ANALYTICS_";
export const SET_PROJECT_VIEW_MODE = "SET_PROJECT_VIEW_MODE";

/* DASHBOARD */
export const GET_DASHBOARD = "GET_DASHBOARD";

/* BILLING AND PLANS */
export const GET_BILLING_PLANS = "GET_BILLING_PLANS";

/* API KEYS */
export const GET_ACCESS_KEYS = "GET_ACCESS_KEYS";
export const SAVE_ACCESS_KEYS = "SAVE_ACCESS_KEYS";
export const DELETE_ACCESS_KEYS = "DELETE_ACCESS_KEYS";
export const SET_ACCESS_KEYS_LOADING = "SET_ACCESS_KEYS_LOADING";

export const GET_USER_DISPLAY = "GET_USER_DISPLAY";